import { jsx as _jsx } from "react/jsx-runtime";
import { default as MapGL } from "react-map-gl";
import { MapContainer } from "./styled";
import "mapbox-gl/dist/mapbox-gl.css";
export const Map = ({ children, ...rest }) => {
    return (_jsx(MapContainer, { children: _jsx(MapGL, { ...rest, mapboxAccessToken: process.env.ACCESS_TOKEN, children: children }) }));
};
